import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../services/central-api/dispatch';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';

interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    zIndex: number;
}

export default function PoliceStationDropdown({ value, setValue, zIndex }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);


    async function getPoliceStations() {
        try {
            const policeStations = await dispatchService.getPoliceStations();
            setItems(policeStations.map((item) => {
                return {
                    label: item.name,
                    value: item.id,
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getPoliceStations();
    }, []);

    return (
        <FilterDropdown
            label={translate('policeStation')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
        />
    );
}
